import { ShareResourceEnum } from 'modules/share/enum/share-resource-enum'
import { formUrl } from 'shared/utils/links/form-url'

export const getShareUrl = (type: ShareResourceEnum, hash: string) => {
  return formUrl(`/share?hash=${hash}&type=${type}`)
}
